<img class="image" [src]="this.imageSrc" />
<div class="content-container">
  <h2 class="title">{{ this.title }}</h2>
  <p class="subtitle">{{ this.subtitle }}</p>
</div>
